export const WHATSAPP_BASE_URL = "https://api.whatsapp.com/send";

export const TERMS_LINK =
  "https://drive.google.com/file/d/1KmbKUU_mjIW00fbFDslrq76iqRU_TLN3/view";

export const SHOPEE_TERMS_LINK =
  "https://drive.google.com/file/d/1r-noAvHg46EoIv0r8cuVlkWd6CmU_Fnp/view?usp=sharing";
export const SPAY_TERMS_LINK =
  "https://drive.google.com/file/d/1GQssSKxR7oCBh6oru00SNCT-HMkWWsyZ/view?usp=sharing";

export const PRIVACY_LINK = "https://www.my.abbott/privacy-policy.html";

export const ABBOTT_PHONE = "60132698307";

export const SALE_REP_REWARD_MAPPING: Record<string, string> = {
  HCP691: "TNG",
  HCP692: "TNG",
  HCP693: "TNG",
  HCP694: "TNG",
  HCP695: "TNG",
  HCP696: "TNG",
  HCP697: "TNG",
  HCP698: "TNG",
  HCP699: "TNG",
  HCP700: "TNG",
  HCP701: "TNG",
  HCP702: "TNG",
  HCP703: "TNG",
  HCP704: "TNG",
  HCP705: "TNG",
  HCP706: "TNG",
  HCP707: "TNG",
  HCP708: "TNG",
  HCP709: "TNG",
  HCP710: "Sarawak Pay",
  HCP711: "Shopee",
  HCP712: "Sarawak Pay",
  HCP713: "Shopee",
  HCP714: "TNG",
};
